import { GaEvent } from '../Libraries/EventTracking';
import { addClass, find, findMany, on, removeClass } from '../Libraries/helpers';

const ProductSpecs = () => {
    const tabs = findMany('[data-spec-tab]').map(button => {
        const id = button.getAttribute('href');

        return {
            id,
            button,
            target: find(id),
        }
    });

    const dropdown = find('[data-spec-select]')

    const toggle = active => {
        tabs.forEach(tab => {
            addClass(tab.button, 'decoration-transparent')
            removeClass(tab.button, 'decoration-black')
            removeClass(tab.target, 'highlight')
            addClass(tab.target, 'hidden')
        });

        removeClass(active.button, 'decoration-transparent')
        addClass(active.button, 'decoration-black')
        addClass(active.target, 'highlight')
        removeClass(active.target, 'hidden')

        setTimeout(() => {
            removeClass(active.target, 'highlight')
        }, 300)

        GaEvent({
            category: 'Products',
            action: 'Product Specification',
            label: active.button.innerText,
        })

        dropdown.value = active.id;
    }

    tabs.forEach(tab => {
        on('click', event => {
            event.preventDefault()
            history.replaceState ? history.replaceState(null, null, tab.id) : document.location.hash = tab.id;
            toggle(tab)
        }, tab.button, false)
    })

    on('change', () => {
        const tag = tabs.find(tab => tab.id === dropdown.value)

        toggle(tag)
    }, dropdown)

    if (document.location.hash) {
        const defaultTab = tabs.find(tab => tab.id === document.location.hash)

        if (defaultTab) {
            toggle(defaultTab)

            document.location.hash = 'loading';

            requestAnimationFrame(() => {
                document.location.hash = defaultTab.id;
            })
        }
    }

    return null
};

export default ProductSpecs
